import React from 'react';
import PropTypes from 'prop-types';

import {
  Button, // Material UI ButtonBase
  ExpandIcon,
  Placeholder,
  LeftDecorationContainer,
  ButtonLabel,
  SubText,
  ButtonContent,
} from './SelectButton.styled';

const SelectButton = React.forwardRef(
  (
    { onClick, leftDecoration, name, placeholder, open, disabled, subText },
    ref
  ) => (
    <Button
      onClick={onClick}
      ref={ref}
      disableRipple
      disabled={disabled}
      data-testid="selector"
    >
      <ButtonContent>
        {name ? (
          <>
            {leftDecoration && (
              <LeftDecorationContainer>
                {leftDecoration}
              </LeftDecorationContainer>
            )}
            <ButtonLabel disabled={disabled}>{name}</ButtonLabel>
          </>
        ) : (
          <Placeholder>{placeholder}</Placeholder>
        )}
        {subText && <SubText>{subText}</SubText>}
      </ButtonContent>
      <ExpandIcon title="open-close-icon" open={open} disabled={disabled} />
    </Button>
  )
);

SelectButton.propTypes = {
  disabled: PropTypes.bool,
  onClick: PropTypes.func,
  leftDecoration: PropTypes.element,
  name: PropTypes.string,
  subText: PropTypes.string,
  placeholder: PropTypes.string,
  open: PropTypes.bool,
};

SelectButton.defaultProps = {
  disabled: false,
  leftDecoration: undefined,
  name: undefined,
  subText: undefined,
  placeholder: undefined,
  open: false,
  onClick: undefined,
};

export default SelectButton;
